module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/renterBook.svg?838fd213";